import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "gh_token";

export const getToken = () => {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(TOKEN_KEY);
};

export const setToken = (t) => {
  if (typeof window === "undefined") return;
  if (t) window.localStorage.setItem(TOKEN_KEY, t);
  else window.localStorage.removeItem(TOKEN_KEY);
};

export const clearToken = () => setToken(null);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${t}`;
  }
  return config;
});

export const submitAuditRequest = async (payload) => {
  const { data } = await api.post("/audit-requests", payload);
  return data;
};

export const authLogin = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  return data; // { token, user }
};

export const authRegister = async ({ email, password, name }) => {
  const { data } = await api.post("/auth/register", { email, password, name });
  return data; // { token, user }
};

export const authMe = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

export const dashboardSummary = async () => {
  const { data } = await api.get("/dashboard/summary");
  return data;
};

export const dashboardCases = async () => {
  const { data } = await api.get("/dashboard/cases");
  return data;
};

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
